export default {
  SEND_DMS: 'SEND_DMS'
}
